<!-- Normal -->
<ng-container *ngIf="!isSvgIcon()">
	<mat-icon
		class="Icon"
		[class.Icon--left]="spaceDirection === EIconSpace.left"
		[class.Icon--right]="spaceDirection === EIconSpace.right"
		[class.Icon--tiny]="iconSize === EIconSize.tiny"
		[class.Icon--small]="iconSize === EIconSize.small"
		[class.Icon--normal]="iconSize === EIconSize.normal"
		[class.Icon--medium]="iconSize === EIconSize.medium"
		[class.Icon--large]="iconSize === EIconSize.large"
		[class.Icon--extraLarge]="iconSize === EIconSize.extraLarge"
		[style.right.px]="iconMoveLeftToRight"
		[style.top.px]="iconMoveTopToBotton"
	>
		{{ icon }}
	</mat-icon>
</ng-container>
<!-- Svg -->
<ng-container *ngIf="isSvgIcon()">
	<mat-icon
		class="Icon"
		[svgIcon]="icon"
		[class.Icon--left]="spaceDirection === EIconSpace.left"
		[class.Icon--right]="spaceDirection === EIconSpace.right"
		[class.Icon--tiny]="iconSize === EIconSize.tiny"
		[class.Icon--small]="iconSize === EIconSize.small"
		[class.Icon--normal]="iconSize === EIconSize.normal"
		[class.Icon--medium]="iconSize === EIconSize.medium"
		[class.Icon--large]="iconSize === EIconSize.large"
		[class.Icon--extraLarge]="iconSize === EIconSize.extraLarge"
		[style.right.px]="iconMoveLeftToRight"
		[style.top.px]="iconMoveTopToBotton"
	/>
</ng-container>
